{
  "name": "continuous-integration",
  "hostname": "ci.safarilaw.com",
  "default": null,
  "development": true,
  "production": false,
  "applicationName": "Safari SOP",
  "sourceVersion": "2be74fe89399a6690dec6049be63d8aeaad59693",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.ci.safarilaw.com/_api/comanage/",
    "apiRootLpms": "https://@.ci.safarilaw.com/_api/lpms/",
    "apiRootSquirrel": "https://@.ci.safarilaw.com/_api/squirrel/",
    "apiRootRms": "https://@.ci.serveport.com/_api/rms/",
    "serveportPortalRoot": "https://app.ci.serveport.com/serve/",
    "serveportAgencyPortalUrl": "https://agency.ci.serveport.com/"
  },
  "auth0": {
    "authorityRoot": "safarilaw-ci.auth0.com",
    "clientId": "JGVozqqiPRJkeoTfLYXi0S6a1XQiBvC7",
    "useLocalStorageCache": true
  },
  "auth": {
    "inactivityTimeout": 15,
    "inactivityWarning": 2
  },
  "statusApp": {
    "apiRootUrl": "https://@.ci.safarilaw.com/_api/maintenance/",
    "code": "_otSSDT9qMnGUM_kQKRl_NtGP_X0QjQfP2MT36jevuGnAzFuuPbGmA==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": true,
    "devExceptions": true,
    "enableMatterSubtypePicklistSettingsEditing": true,
    "showMatterSubtypePicklistSettings": true,
    "showCustomPicklistSettings": true,
    "enableCustomPicklistSettingsEditing": true,
    "inputRelativeValidation": true,
    "showServiceAccountSettings": true,
    "notificationBellEnabled": true,
    "enableCloneMatter": true,
    "enableServeportPortalEdit": true,
    "enableServiceOfProcessBusinessHours": true,
    "enableBlackMamba": true,
    "enableFederalBenefitExemptionStatus": true,
    "enableEmailFileViewer": true,
    "enableNonPdfIntakeUpload": true,
    "enablePdfTemplates": true,
    "enableTaskGroups": true
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "029d8bde-aa1d-49b5-b5cf-aea4429d0ebb"
    },
    "appInsights": {
      "connectionString": "InstrumentationKey=57351800-d3f6-4057-9235-ef1c2d5d6061;IngestionEndpoint=https://eastus-1.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=83289e5f-e93d-44ee-89fb-04527bee6c72"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "showSwWarning": true,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20,
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self"
    },
    "reports": {
      "key": "Z70R-XG6J5I-274219-0W0Y0F-734Y3H-5I460R-0H445W-4F6S27-2G5S1J-4P291I-2E5N"
    },
    "ckeditor": {
      "key": "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MjQ1OTUxOTksImp0aSI6ImQ1NWI1Mjc0LTg0YTUtNDZmZC04N2E0LWFlYzZiNmUwOGE3YyIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwibGljZW5zZVR5cGUiOiJkZXZlbG9wbWVudCIsImZlYXR1cmVzIjpbIkRSVVAiXSwidmMiOiJlOGFlNTQ4NCJ9.oqxsFLsEfR0gmD4JFvTS5TgzpQ4IJ3BwZirvcVT55JzMJxksQcQ8x2UCqNJjtU_ULe3AhCaYNtLrpgJudG_FeQ"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "lpms",
        "name": "matters",
        "url": "signalr/matters"
      },
      {
        "api": "lpms",
        "name": "correspondences",
        "url": "signalr/correspondences"
      },
      {
        "api": "lpms",
        "name": "notifications",
        "url": "signalr/notifications"
      },
      {
        "api": "lpms",
        "name": "intake-files",
        "url": "signalr/intake-files"
      }
    ]
  }
}
